import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, NavLink } from 'react-router-dom';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import Recaptcha from 'react-google-recaptcha';
import moment from 'moment';

import Loader from '../components/loader';
import ToastHandler from '../components/toasthandler';
import { States, FundsSource, Occupations, ExpectedVolumes, PurposeAndIntendedNature } from '../components/selectlists';
import OnfidoSdk from './kyc2';
import FormSelect from '../components/formselect';

import {
  createIdentity,
  fetchIdentity,
  fetchCountries,
} from '../actions';

class Kyc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stage: 1,
      firstName: '',
      lastName: '',
      birthDate: null,
      nationality: '',
      birthPlace: '',
      address: '',
      houseNo: '',
      street: '',
      zipCode: '',
      city: '',
      countryHandle: '',
      provinceHandle: '',
      fundsSource: '',
      occupation: '',
      purpose: '',
      expectedVolume: '',
      // fundsSource: {
      //   sourceDetails: '',
      //   sourceHandle: '',
      // },
      modalComponent: null,
      recaptchaRef: React.createRef(),
      detailsConsent: false,
      errors: null,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.selectChange = this.selectChange.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.getIdentity = this.getIdentity.bind(this);
    this.onSubmitWithReCAPTCHA = this.onSubmitWithReCAPTCHA.bind(this);
    this.returnYears = this.returnYears.bind(this);
    this.handleCheckToggle = this.handleCheckToggle.bind(this);
  }

  async componentDidMount() {
    const { dispatch, user } = this.props;
    dispatch(fetchCountries());
    let stage = 1;
    let firstName;
    let lastName;
    let birthDate;
    let nationality;
    let birthPlace;
    let address;
    let zipCode;
    let city;
    let countryHandle;
    let provinceHandle;

    let province;
    let street;
    let houseNo;

    if (countryHandle === 'US') {
      province = provinceHandle;
    }

    let infoComplete;

    if (user && user.me && user.me.identity) {
      if (user.me.identity.firstName) {
        firstName = user.me.identity.firstName;
      }
      if (user.me.identity.lastName) {
        lastName = user.me.identity.lastName;
      }
      if (user.me.identity.birthDate) {
        birthDate = user.me.identity.birthDate;
      }
      if (user.me.identity.nationality) {
        nationality = user.me.identity.nationality;
      }
      if (user.me.identity.birthPlace) {
        birthPlace = user.me.identity.birthPlace;
      }
      if (user.me.identity.address) {
        address = user.me.identity.address;
      }
      if (user.me.identity.zipCode) {
        zipCode = user.me.identity.zipCode;
      }
      if (user.me.identity.city) {
        city = user.me.identity.city;
      }
      if (user.me.countryHandle) {
        countryHandle = user.me.countryHandle;
      }
      if (user.me.identity.provinceHandle) {
        provinceHandle = user.me.identity.provinceHandle;
      }
      if (user.me.identity.houseNo) {
        houseNo = user.me.identity.houseNo;
      }
      if (user.me.identity.street) {
        street = user.me.identity.street;
      }

      infoComplete = user.me.identity.firstName && user.me.identity.lastName && user.me.identity.birthDate && user.me.identity.nationality && user.me.identity.birthPlace && (user.me.identity.address || (user.me.identity.street && user.me.identity.houseNo)) && user.me.identity.zipCode && user.me.identity.city && user.me.countryHandle;
    }

    if (user && user.me && (Object.keys(user.me.identity).length > 0)) {
      stage = 2;
    }

    if (infoComplete) {
      stage = 2;
      this.getIdentity();
    }

    this.setState({
      stage,
      firstName,
      lastName,
      birthDate,
      nationality,
      birthPlace,
      address,
      street,
      houseNo,
      zipCode,
      city,
      countryHandle,
      provinceHandle,
    });
  }

  componentDidUpdate() {
    const { user } = this.props;
    const isVerified = user && user.me && user.me.flags && user.me.flags.verified;
    if (isVerified) {
      window.location.href = '/';
    }
  }

  async onSubmitWithReCAPTCHA(event) {
    event.preventDefault();
    const token = await this.state.recaptchaRef.current.executeAsync();
  }

  // onSubmitWithReCAPTCHA = async (event) => {
  //   event.preventDefault();
  //   const token = await this.state.recaptchaRef.current.executeAsync();
  // }

  showError(e) {
    console.log('Error with the captcha');
  }

  handleCheckToggle() {
    this.setState((prev) => ({
      ...prev,
      detailsConsent: !prev.detailsConsent
    }));
  }

  handleSubmit(event) {
    // event.preventDefault();
    const { dispatch } = this.props;
    const { firstName, lastName, birthDate, nationality, birthPlace, houseNo, street, zipCode, city, countryHandle, provinceHandle, recaptchaRef, detailsConsent, fundsSource, occupation, expectedVolume, purpose } = this.state;
    const recaptchaValue = recaptchaRef.current.getValue();

    let province;

    if (countryHandle === 'US') {
      province = provinceHandle;
    }

    if (countryHandle === 'GB') {
      const check = this.isValidPostcode(zipCode);
      if (!check) {
        this.setState({
          errors: { error: 'Invalid postcode' },
        });
        return;
      }
    }

    let data = {
      firstName: firstName,
      lastName: lastName,
      birthDate: birthDate,
      nationality: nationality,
      birthPlace: birthPlace,
      zipCode: zipCode,
      city: city,
      countryHandle: countryHandle,
      provinceHandle: province,
      occupation: occupation,
      expectedVolume: expectedVolume,
      purpose: purpose,
      captcha: recaptchaValue,
      houseNo,
      street,
    }

    if (fundsSource) {
      data.fundsSource = fundsSource;
    }

    if (detailsConsent) {
      dispatch(createIdentity(data))
        .then((res) => {
          if (res.type === 'CREATE_IDENTITY_SUCCESS') {
            window.scrollTo(0, 0);
            this.getIdentity();
            this.setState({ stage: 2 });
            window.location.reload();
          }
        });
    }
  }

  getIdentity() {
    const { dispatch } = this.props;
    dispatch(fetchIdentity())
      .then((res) => {
        if (res.type === 'FETCH_IDENTITY_SUCCESS') {
          this.toggleModal(null)
        }
      });
  }

  isValidPostcode(postalCode) {
    const postcodeRegEx = /^[a-z]{1,2}\d[a-z\d]?\s*\d[a-z]{2}$/i;
    return postcodeRegEx.test(postalCode);
  }

  toggleModal(component) {
    this.setState({
      modalComponent: component
    });
  }

  handleChange(event) {
    const { id, value } = event.target;
    this.setState({ [id]: value });
  }

  selectChange(event, item) {
    this.setState({ [item]: event.value });
  }

  completeKyc(event) {
    event.preventDefault();
    window.location.href = '/';
  }

  returnYears() {
    let years = []
    for(let i = moment().year() - 100; i <= moment().year(); i++) {
      years.push(<option value={i}>{i}</option>);
    }
    return years;
  }

  render() {
    const { errors, loading, user, documents, countries, location: { pathname } } = this.props;
    const { stage, firstName, lastName, birthDate, nationality, birthPlace, address, houseNo, street, zipCode, city, countryHandle, provinceHandle, recaptchaRef, detailsConsent, fundsSource, expectedVolume, occupation, purpose } = this.state;
    const isVerified = user && user.me && user.me.flags && user.me.flags.verified;
    const addressExist = (houseNo && street) || address;
    const validationApiErrors = this.state.errors || errors;

    let completed = firstName && lastName && birthDate && nationality && birthPlace && addressExist && zipCode && city && countryHandle && detailsConsent && occupation && expectedVolume && purpose;
    let idFile;
    let addressFile;
    let allowEdit = false;

    if (documents && documents.documents) {
      idFile = documents.documents.filter(function(item) {
        return item.group === 'ID';
      });
      addressFile = documents.documents.filter(function(item) {
        return item.group === 'ADDRESS';
      });
    }

    const uploadsCompleted = (addressFile && addressFile[0] && addressFile[0].status && (addressFile[0].status !== 'REJECTED')) && (idFile && idFile[0] && (idFile[0].status !== 'REJECTED'));

    if (uploadsCompleted) {
      allowEdit = false;
    }

    let nationalitySort;
    let countrySort;

    if ((countries && countries.length)) {
      nationalitySort = countries.sort(function(a, b) {
         return a.nationality.localeCompare(b.nationality);
      });
      countrySort = countries.sort(function(a, b) {
         return a.name.localeCompare(b.name);
      });
    }

    const stateSort = States.sort(function(a, b) {
       return a.name.localeCompare(b.name);
    });

    const fundsSourceLoop = FundsSource.map((item, idx) => {
      let value;
      let label;
      if (item && item.handle) {
        value = item.handle;
      }
      if (item && item.name) {
        label = item.name;
      }
      return { value, label };
    });

    const occupationLoop = Occupations.map((item, idx) => {
      let value;
      let label;
      if (item && item.handle) {
        value = item.handle;
      }
      if (item && item.name) {
        label = item.name;
      }
      return { value, label };
    });

    const purposeAndIntendedNatureLoop = PurposeAndIntendedNature.map((item, idx) => {
      let value;
      let label;
      if (item && item.handle) {
        value = item.handle;
      }
      if (item && item.name) {
        label = item.name;
      }
      return { value, label };
    });

    const expectedVolumeLoop = ExpectedVolumes.map((item, idx) => {
      let value;
      let label;
      if (item && item.handle) {
        value = item.handle;
      }
      if (item && item.name) {
        label = item.name;
      }
      return { value, label };
    });

    const nationalityLoop = nationalitySort && nationalitySort.map((item, index) => {
      let value;
      let label;
      if (item && item.nationality) {
        value = item.nationality;
        label = item.nationality;
      }
      // if (item && item.name) {
      //   label = item.name;
      // }
      return { value, label };
    });

    const countryLoop = countrySort && countrySort.map((item, index) => {
      let value;
      let label;
      if (item && item.name) {
        value = item.name;
      }
      if (item && item.name) {
        label = item.name;
      }
      return { value, label };
    });

    const countryHandleLoop = countrySort && countrySort.map((item, index) => {
      let value;
      let label;
      if (item && item['alpha-2']) {
        value = item['alpha-2'];
      }
      if (item && item.name) {
        label = item.name;
      }
      return { value, label };
    });

    const provinceLoop = stateSort && stateSort.map((item, index) => {
      let value;
      let label;
      if (item && item.handle) {
        value = item.handle;
      }
      if (item && item.name) {
        label = item.name;
      }
      return { value, label };
    });

    if (loading || isVerified) {
      return (
        <div className="center-loader">
          <Loader logo />
        </div>
      );
    }

    const minDate = moment().subtract(18, 'years').format('YYYY-MM-DD');

    // Stage 1; Show Identity form.

    // Stage 2; Show Onfido SDK modal.

    // Stage 3; when verification is completed but still waiting for result.
    // It will display either verification is failed or in progress.

    if (stage === 2) {
      return <OnfidoSdk {...this.props} />;
    }

    return (
      <div className="grid-x align-center">
        <div className="cell small-12 medium-11 large-9">
          <form className="login-content kyc" id="identity-create" onSubmit={this.onSubmitWithReCAPTCHA}>
            <Recaptcha
              ref={recaptchaRef}
              sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
              onChange={this.handleSubmit}
              size="invisible"
              onExpired={() => {}}
              onErrored={(e) => {
                this.showError(e);
              }}
            />
            <ToastHandler errors={validationApiErrors} />

            <div className="cell panel kyc-item">
              <div className="panel-label">
                Welcome to the Vaultoro platform and community!
              </div>
              <p>
                Thank you for choosing us. We appreciate it and are sure you will benefit from being here.
              </p>
              <p>
                We take the info below because the gold you buy and secure in the Zurich top-tier vaulting facility is allocated to you as your legal property, off our books. This is not the same with other fiat based exchanges where your assets are legally owned by the bank those exchanges use and not insured.
              </p>
              <p>
                You&apos;re just minutes away from enjoying the full power and security of Vaultoro&apos;s, physical allocated gold and cryptocurrency exchange!
              </p>
              <p>
                Welcome to dealing only in rare assets.
              </p>
            </div>

            <div className="cell panel kyc-item">
              <div className="panel-label">
                What&apos;s your first name?
              </div>
              <p>
                The same first name as displayed on ID
              </p>
              <div>
                <div className="input-wrapper">
                  <input className="input" type="text" name="firstName" placeholder="First Name" value={firstName} id="firstName" onChange={this.handleChange} required />
                </div>
              </div>
            </div>

            <div className="cell panel kyc-item">
              <div className="panel-label">
                What&apos;s your last name?
              </div>
              <p>
                The same last name as displayed on ID
              </p>
              <div>
                <div className="input-wrapper">
                  <input className="input" type="text" name="lastName" placeholder="Last Name" value={lastName} id="lastName" onChange={this.handleChange} required />
                </div>
              </div>
            </div>

            <div className="cell panel kyc-item">
              <div className="panel-label">
                When were you born?
              </div>
              <p>
                You must be 18 years or older
              </p>
              <div className="input-wrapper">
                <input
                  className="input"
                  value={birthDate}
                  type="date"
                  id="birthDate"
                  name="birthDate"
                  onChange={this.handleChange}
                  max={minDate}
                />
              </div>
            </div>

            <div className="cell panel kyc-item">
              <div className="panel-label">
                Source of Funds
              </div>
              <div>
                <div>
                  <FormSelect
                    value={fundsSource}
                    options={fundsSourceLoop}
                    placeholder="Source of funds"
                    onChange={(event) => this.selectChange(event, 'fundsSource')}
                  />
                </div>
              </div>
            </div>

            <div className="cell panel kyc-item">
              <div className="panel-label">
                Expected Volume (&#128;/&#36;)
              </div>
              <div>
                <div>
                  <FormSelect
                    value={expectedVolume}
                    options={expectedVolumeLoop}
                    placeholder="Expected Volume"
                    onChange={(event) => this.selectChange(event, 'expectedVolume')}
                  />
                </div>
              </div>
            </div>

            <div className="cell panel kyc-item">
              <div className="panel-label">
                Purpose and intended nature of your business with Vaultoro
              </div>
              <div>
                <div>
                  <FormSelect
                    value={purpose}
                    options={purposeAndIntendedNatureLoop}
                    placeholder="Purpose"
                    onChange={(event) => this.selectChange(event, 'purpose')}
                  />
                </div>
              </div>
            </div>

            <div className="cell panel kyc-item">
              <div className="panel-label">
                Employment Status / Occupation
              </div>
              <div>
                <div>
                  <FormSelect
                    value={occupation}
                    options={occupationLoop}
                    placeholder="Employment Status / Occupation"
                    onChange={(event) => this.selectChange(event, 'occupation')}
                  />
                </div>
              </div>
            </div>

            <div className="cell panel kyc-item">
              <div className="panel-label">
                What citizenship do you hold?
              </div>
              <div>
                {/* <div className="input-wrapper">
                  <select className="input" id="nationality" value={nationality} onChange={this.handleChange} placeholder="nationality" required>
                    <option value="" hidden disabled selected>Citizenship</option>
                    {nationalityLoop}
                  </select>
                </div> */}
                <div>
                  <FormSelect
                    value={nationality}
                    options={nationalityLoop}
                    placeholder="Citizenship"
                    onChange={(event) => this.selectChange(event, 'nationality')}
                    isSearchable
                  />
                </div>
              </div>
            </div>

            <div className="cell panel kyc-item">
              <div className="panel-label">
                Where is your birthplace?
              </div>
              <div>
                {/* <div className="input-wrapper">
                  <select className="input" id="birthPlace" value={birthPlace} onChange={this.handleChange} placeholder="birthPlace" required>
                    <option value="" hidden disabled selected>Birthplace</option>
                    {countryLoop}
                  </select>
                </div> */}
                <div>
                  <FormSelect
                    value={birthPlace}
                    options={countryLoop}
                    placeholder="Birthplace"
                    onChange={(event) => this.selectChange(event, 'birthPlace')}
                    isSearchable
                  />
                </div>
              </div>
            </div>

            <div className="cell panel kyc-item">
              <div className="panel-label">
                What is your current address?
              </div>
              <div>
                <div className="input-wrapper">
                  <input className="input" type="text" name="houseNo" placeholder="House no." value={houseNo} id="houseNo" maxLength="9" onChange={this.handleChange} required />
                </div>
                <div className="input-wrapper">
                  <input className="input" type="text" name="street" placeholder="Street" value={street} id="street" maxLength="59" onChange={this.handleChange} required />
                </div>
                <div className="input-wrapper">
                  <input className="input" type="text" name="zipCode" placeholder="Postal / Zip code" value={zipCode} maxLength="9" id="zipCode" onChange={this.handleChange} required />
                </div>
                <div className="input-wrapper">
                  <input className="input" type="text" name="city" placeholder="City" value={city} id="city" maxLength="59" onChange={this.handleChange} required />
                </div>
                {/* <div className="input-wrapper">
                  <select className="input" id="countryHandle" value={countryHandle} onChange={this.handleChange} placeholder="countryHandle" required>
                    <option value="" hidden disabled selected>Country</option>
                    {countryLoop}
                  </select>
                </div> */}
                <div>
                  <FormSelect
                    value={countryHandle}
                    options={countryHandleLoop}
                    placeholder="Country"
                    onChange={(event) => this.selectChange(event, 'countryHandle')}
                    isSearchable
                  />
                </div>
                { countryHandle === 'US' && (
                  // <div className="input-wrapper">
                  //   <select className="input" id="provinceHandle" value={provinceHandle} onChange={this.handleChange} placeholder="provinceHandle" required>
                  //     <option value="" hidden disabled selected>Province/State</option>
                  //     {provinceLoop}
                  //   </select>
                  // </div>
                  <div style={{ marginTop: '16px' }}>
                    <FormSelect
                      value={provinceHandle}
                      options={provinceLoop}
                      placeholder="Province/State"
                      onChange={(event) => this.selectChange(event, 'provinceHandle')}
                      isSearchable
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="checkbox-wrapper">
              <div id="details-consent" className={detailsConsent ? 'cb-check true' : 'cb-check'} onClick={this.handleCheckToggle}>
                <div className="cb-box" />
                <div className="cb-label">
                  I hereby confirm that the information given in this form is true, complete and accurate.
                </div>
              </div>
            </div>
            <div className="cell panel kyc-item">
              <div className="" style={{ color: '#cd5c5c', fontSize: '1.25rem', fontWeight: 900 }}>
                Please note it is not possible to change your data later.
              </div>
            </div>

            <button style={{ width: '100%' }} className="vlt-button vt-kyc" type="submit" htmlFor="identity-create" disabled={!completed}>
              <span>
                Continue
              </span>
            </button>

          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.user.token,
  user: state.user,
  documents: state.user.identity,
  errors: state.user.errors,
  success: state.user.success,
  loading: state.user.loading,
  countries: state.status.countries,
});

export default withRouter(connect(mapStateToProps)(Kyc));
